import React from 'react';
import Grid from '@mui/material/Grid2';
import SystemCard from './system_card';
import LOGO_EARTHQUAKE_SYSTEM from '../_img/logo_earthquake_system.png';
import LOGO_DASHBOARD from '../_img/logo_dashboard.png';

const TopGrid = ({ onEarthquakeClick, onDashboardClick }) => {
    const systemData = [
        {
            id: 'earthquake',
            image: LOGO_EARTHQUAKE_SYSTEM,
            altText: '地震対応支援システム イメージ画像',
            title: '地震対応支援システム',
            description: '地震発生時の報告業務を実施',
            onClick: onEarthquakeClick,
        },
        {
            id: 'prevention',
            image: LOGO_DASHBOARD,
            altText: '取水停止判断システム イメージ画像',
            title: '取水停止判断システム',
            description: '災害リスクの確認\n取水停止の判断に活用',
            onClick: onDashboardClick,
        },
    ];

    return (
        <Grid
            container
            spacing={4}
            justifyContent="center"
            alignItems="stretch"
            sx={{ width: '100%' }}
        >
            {systemData.map((system) => (
                <Grid key={system.id} size={{ xs: 12, sm: 6 }}>
                    <SystemCard
                        image={system.image}
                        altText={system.altText}
                        title={system.title}
                        description={system.description}
                        onClick={system.onClick}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default TopGrid;